import request from '@/modules/base/util/request'
import config from 'config'
import settingsConfig from '@/modules/settings/config'
import { pick, pickBy } from 'lodash'

const baseUrl = `${config.resourceHost}`

export const UserService = {
  create: (user) => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}user`, {
        method: 'POST',
        auth: true,
        isConcurrent: true,
        data: user,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },

  edit: (user) => {
    return new Promise((resolve, reject) => {
      const { id } = user
      request(`${baseUrl}user/${id}`, {
        method: 'PUT',
        auth: true,
        isConcurrent: true,
        data: user,
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },

  editSelf: (data) => {
    return new Promise((resolve, reject) => {
      request(settingsConfig.getUserInfo, {
        method: 'PUT',
        auth: true,
        isConcurrent: true,
        data: pick(data, ['firstName', 'lastName', 'layoutSettings']),
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },

  updatePassword: (password) => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}user/password`, {
        method: 'PUT',
        auth: true,
        isConcurrent: true,
        data: { password },
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },

  lock: (id) => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}user/${id}/lock`, {
        method: 'PUT',
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },

  unlock: (id) => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}user/${id}/unlock`, {
        method: 'PUT',
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },

  getById: (id) => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}user/${id}`, {
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },

  find: (searchTerm, offset = null, limit = null, hasConfirmedEmail = undefined, fileId = undefined, excludeLocked = undefined) => {
    const query = new URLSearchParams(pickBy({ limit, offset, hasConfirmedEmail, fileId, excludeLocked }, Boolean))
    return new Promise((resolve, reject) => {
      request(`${baseUrl}find/user/${searchTerm || '*'}?${query.toString()}`, {
        method: 'GET',
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },

  getAll: (options) => {
    const { offset, limit } = options

    return new Promise((resolve, reject) => {
      const url = `${baseUrl}user?offset=${offset}&limit=${limit}`
      return request(url, { auth: true, isConcurrent: true })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },

  delete: (id) => {
    return new Promise((resolve, reject) => {
      return request(`${baseUrl}user/${id}`, {
        auth: true,
        isConcurrent: true,
        method: 'DELETE',
      })
        .then((result) => resolve(result))
        .catch(error => reject(error))
    })
  },
}
